<template>
<div class="distribution" :style="{'grid-template-columns': templateColumns}">
	<div class="col" v-for="(column, index) in distribution" :key="column + index">
	</div>
</div>	
</template>

<script>
export default {
	name:"ColumnDistributionIcon",
	props: ['distribution'],
	computed: {
		templateColumns() {
			return this.distribution.join('fr ') + 'fr'
		}
		
	}
}
</script>


<style scoped>
.distribution {
	height: 34px;
	width: 45px;
	display: grid;
	grid-template-columns: repeat(3, 3fr);
	grid-template-rows: 1fr;
	grid-column-gap: 2px;
	grid-row-gap: 0px;
}

.col {
	@apply 
		border
		border-solid
		border-dull;
}

.selected .col {
	@apply
		border
		border-solid
		border-primary
}

</style>